import constants from '../constants/common';

const getBlockIdByElement = (element) => {
  if (!element || !element.id || !element.id.startsWith(constants.BLOCK_ID_PREFIX)) return null;

  return element.id.substr(constants.BLOCK_ID_PREFIX.length + 1).replace(/-[^-]+$/, '');
};

export default getBlockIdByElement;
